import Modal from 'react-bootstrap/Modal';
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import '../../Style/Checkbox.scss';
import { errorAlert, handleSuccess } from '../../Components/Alerts';
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import '../../Style/__button.scss';
import '../ClientsCRUD/ClientsModal.scss';
import './CashRegisterModal.scss';
import TextField from '@mui/material/TextField';
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from 'react-select';
import { AddElementsButton } from '../../Components/AddElementsButton';

function InsertCashRegister(props) {
    const headers = authHeader();
    const isEditMode = props.mode === "edit";

    const [accName, setAccName] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [adress, setAdress] = useState("");
    const [cityID, setCityID] = useState("");
    const [accEmail, setAccEmail] = useState("");
    const [comment, setComment] = useState("");
    const [phone, setPhone] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [accountID, setAccountID] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [stateid, setStateID] = useState("");
    const [stateName, setStateName] = useState("");
    const [cityName, setCityName] = useState("");
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [city, setCity] = useState([]);
    const [filteredCity, setFilteredCity] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [stateError, setStateError] = useState("");
    const [cityError, setCityError] = useState("");
    const [accNameError, setAccNameError] = useState("");
    const [idNumberError, setIdNumberError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const initialSnapshotRef = useRef(null);
    const [showConfirmClose, setShowConfirmClose] = useState(false);

    const resetForm = () => {
        setAccountID(null);
        setAccName("");
        setIdNumber("");
        setAdress("");
        setCityID("");
        setStateID("");
        setAccEmail("");
        setComment("");
        setPhone("");
        setIsActive(true);
        setStateName("");
        setCityName("");
        setCity([]);
        setStateError("");
        setCityError("");
        setAccNameError("");
        setIdNumberError("");
        setAddressError("");
        setEmailError("");
        setPhoneError("");
        setIsSubmitting(false);
        initialSnapshotRef.current = null;
        setShowConfirmClose(false);
    };

    const setFormFromCashRegister = (cashRegister) => {
        setAccountID(cashRegister?.AccountID ?? null);
        setAccName(cashRegister?.AccountName ?? "");
        setIdNumber(cashRegister?.IdentificationNumber ?? "");
        setAdress(cashRegister?.Adress ?? "");
        setCityID(cashRegister?.CityID ?? "");
        setStateID(cashRegister?.StateID ?? "");
        setAccEmail(cashRegister?.Email ?? "");
        setComment(cashRegister?.Comment ?? "");
        setPhone(cashRegister?.PhoneNumbers ?? "");
        setIsActive(typeof cashRegister?.IsActive === "boolean" ? cashRegister.IsActive : true);
        setStateName(cashRegister?.StateName ?? "");
        setCityName(cashRegister?.CityName ?? "");
        setStateError("");
        setCityError("");
        setAccNameError("");
        setIdNumberError("");
        setAddressError("");
        setEmailError("");
        setPhoneError("");
        setIsSubmitting(false);
        initialSnapshotRef.current = {
            accName: cashRegister?.AccountName ?? "",
            idNumber: cashRegister?.IdentificationNumber ?? "",
            adress: cashRegister?.Adress ?? "",
            cityID: cashRegister?.CityID ?? "",
            stateid: cashRegister?.StateID ?? "",
            accEmail: cashRegister?.Email ?? "",
            comment: cashRegister?.Comment ?? "",
            phone: cashRegister?.PhoneNumbers ?? "",
            isActive: typeof cashRegister?.IsActive === "boolean" ? cashRegister.IsActive : true,
        };
    };

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'states', { headers })
            .then((response) => {
                setStates(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const fetchCityByState = async (selectedStateID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Cities/getcitybystate', { headers, params: { stateid: selectedStateID } });
            setCity(response.data);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        if (!props.show) {
            return;
        }

        if (isEditMode) {
            if (!props.initialData) {
                return;
            }

            setFormFromCashRegister(props.initialData);
            if (props.initialData.StateID) {
                fetchCityByState(props.initialData.StateID);
            }
            return;
        }

        resetForm();
    }, [props.show, props.initialData, isEditMode]);

    useEffect(() => {
        setFilteredStates(
            states.filter((data) =>
                data.StateName.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, states]);

    useEffect(() => {
        setFilteredCity(
            city.filter((data) =>
                data.CityName.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, city]);

    const handleInputChange = (newValue) => {
        const inputValue = newValue.replace(/\W/g, '');
        setSearchTerm(inputValue);
    };

    const handleFilterState = (selectedOption) => {
        if (selectedOption && selectedOption.StateID) {
            setStateID(selectedOption.StateID);
            setCityID("");
            setCityName("");
            setCity([]);
            fetchCityByState(selectedOption.StateID);
            setStateName(selectedOption.label);
            setStateError("");
            setCityError("");
        } else {
            setStateID("");
            setStateName("");
            setCityID("");
            setCityName("");
            setCity([]);
        }
    };

    const handleFilterCity = (selectedOption) => {
        if (selectedOption && selectedOption.CityID) {
            setCityID(selectedOption.CityID);
            setCityName(selectedOption.label);
            setCityError("");
        } else {
            setCityID("");
            setCityName("");
        }
    };

    const isDirty = useMemo(() => {
        if (!isEditMode) {
            return (
                accName.trim() !== "" ||
                idNumber !== "" ||
                adress.trim() !== "" ||
                stateid !== "" ||
                cityID !== "" ||
                accEmail !== "" ||
                comment !== "" ||
                phone !== ""
            );
        }

        const snap = initialSnapshotRef.current;
        if (!snap) {
            return false;
        }

        return (
            accName !== snap.accName ||
            idNumber !== snap.idNumber ||
            adress !== snap.adress ||
            cityID !== snap.cityID ||
            stateid !== snap.stateid ||
            accEmail !== snap.accEmail ||
            comment !== snap.comment ||
            phone !== snap.phone ||
            isActive !== snap.isActive
        );
    }, [isEditMode, accName, idNumber, adress, cityID, stateid, accEmail, comment, phone, isActive]);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isSubmitting) {
            return;
        }

        let hasValidationError = false;
        const trimmedAccName = accName.trim();
        const trimmedIdNumber = idNumber.trim();
        const trimmedAddress = adress.trim();
        const trimmedEmail = accEmail.trim();
        const trimmedPhone = phone.trim();
        const trimmedComment = comment.trim();

        if (trimmedAccName === "") {
            setAccNameError("Plotësoni emrin e arkës");
            hasValidationError = true;
        } else {
            setAccNameError("");
        }

        if (trimmedIdNumber === "") {
            setIdNumberError("Plotësoni numrin identifikues");
            hasValidationError = true;
        } else {
            setIdNumberError("");
        }

        if (trimmedAddress === "") {
            setAddressError("Plotësoni adresën");
            hasValidationError = true;
        } else {
            setAddressError("");
        }

        if (trimmedEmail !== "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(trimmedEmail)) {
                setEmailError("Email nuk është valid");
                hasValidationError = true;
            } else {
                setEmailError("");
            }
        } else {
            setEmailError("");
        }

        if (trimmedPhone !== "") {
            const phoneRegex = /^[0-9+\s()-]{6,20}$/;
            if (!phoneRegex.test(trimmedPhone)) {
                setPhoneError("Numri i telefonit nuk është valid");
                hasValidationError = true;
            } else {
                setPhoneError("");
            }
        } else {
            setPhoneError("");
        }

        if (stateid == null || stateid === "") {
            setStateError("Plotësoni shtetin");
            hasValidationError = true;
        } else {
            setStateError("");
        }

        if (cityID == null || cityID === "") {
            setCityError("Plotësoni qytetin");
            hasValidationError = true;
        } else {
            setCityError("");
        }

        if (hasValidationError) {
            return;
        }

        setIsSubmitting(true);

        const payload = {
            AccountName: trimmedAccName,
            LedgerID: 101,
            IdentificationNumber: trimmedIdNumber,
            Adress: trimmedAddress,
            CityID: cityID,
            StateID: stateid,
            VatNumber: "",
            BankAccount: "",
            Email: trimmedEmail,
            Comment: trimmedComment,
            PhoneNumbers: trimmedPhone,
            IsActive: isActive,
            ...(isEditMode
                ? {
                    AccountID: accountID,
                }
                : {}),
        };

        const submitRequest = isEditMode
            ? axios.put(ApiLink.API_URL + 'Accounts/updateAccount', payload, { headers })
            : axios.post(ApiLink.API_URL + 'Accounts/insertAccount', payload, { headers });

        submitRequest
            .then(() => {
                handleSuccess(isEditMode ? "Arka u përditësua me sukses" : "Arka u shtua me sukses");
                resetForm();
                props.onHide();
                props.refreshData();
            })
            .catch((error) => {
                console.error(error);
                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else {
                    errorAlert("Ka ndodhur një gabim i panjohur gjatë përpunimit të kërkesës.");
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const doClose = () => {
        if (isSubmitting) {
            return;
        }

        props.onHide();
        resetForm();
    };

    const handleClose = () => {
        if (isSubmitting) {
            return;
        }

        if (isDirty) {
            setShowConfirmClose(true);
            return;
        }

        doClose();
    };

    return (
        <>
        <Modal
            {...props}
            onHide={handleClose}
            backdrop={isSubmitting ? "static" : true}
            keyboard={!isSubmitting}
            size="lg"
            dialogClassName="clients-modal-dialog cash-register-modal-dialog"
            contentClassName="clients-modal-content cash-register-modal-content"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="clients-modal-header">
                <div className="clients-modal-header-content">
                    <Modal.Title id="contained-modal-title-vcenter" className="clients-modal-title">
                        {isEditMode ? "Përditëso të dhënat e arkës" : "Krijo një Arkë të re"}
                    </Modal.Title>
                    <p className="clients-modal-subtitle">
                        {isEditMode
                            ? "Ndrysho të dhënat e arkës dhe ruaji për përditësim në sistem."
                            : "Plotësoni të dhënat e arkës dhe ruani për ta shtuar në sistem."}
                    </p>
                    <div className="clients-modal-meta">
                        <span className="clients-meta-pill">Fushat me * janë obligative</span>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="clients-modal-body">
                <form onSubmit={handleSubmit} className="clients-form">
                    <section className="clients-section">
                        <h6 className="clients-section-title">Informata Kryesore</h6>
                        <div className="clients-grid clients-grid-2">
                            <div className="clients-field clients-field-full">
                                <TextField
                                    fullWidth
                                    required
                                    id="AccountName"
                                    label="Emri i Arkës *"
                                    variant="outlined"
                                    type="text"
                                    name="AccountName"
                                    value={accName}
                                    onChange={(event) => {
                                        setAccName(event.target.value);
                                        if (accNameError) {
                                            setAccNameError("");
                                        }
                                    }}
                                    autoComplete="off"
                                    size="small"
                                />
                                <span className="clients-error">{accNameError && `${accNameError}`}</span>
                            </div>

                            <div className="clients-field">
                                <TextField
                                    fullWidth
                                    required
                                    id="IdentificationNumber"
                                    label="Numri Identifikues: Psh (01, 02) *"
                                    variant="outlined"
                                    type="text"
                                    name="IdentificationNumber"
                                    value={idNumber}
                                    onChange={(event) => {
                                        setIdNumber(event.target.value);
                                        if (idNumberError) {
                                            setIdNumberError("");
                                        }
                                    }}
                                    autoComplete="off"
                                    size="small"
                                />
                                <span className="clients-error">{idNumberError && `${idNumberError}`}</span>
                            </div>

                            <div className="clients-field">
                                <TextField
                                    fullWidth
                                    required
                                    id="Adress"
                                    label="Adresa *"
                                    variant="outlined"
                                    type="text"
                                    name="Adress"
                                    value={adress}
                                    onChange={(event) => {
                                        setAdress(event.target.value);
                                        if (addressError) {
                                            setAddressError("");
                                        }
                                    }}
                                    autoComplete="off"
                                    size="small"
                                />
                                <span className="clients-error">{addressError && `${addressError}`}</span>
                            </div>

                            <div className="clients-field">
                                <label className="clients-select-label">Përzgjedh Shtetin *</label>
                                <Select
                                    inputId="StateID"
                                    classNamePrefix="clients-select"
                                    value={stateid ? { label: stateName, value: stateid, StateID: stateid } : null}
                                    options={filteredStates.map((data) => ({
                                        label: data.StateName,
                                        value: data.StateID,
                                        StateID: data.StateID,
                                    }))}
                                    onInputChange={handleInputChange}
                                    onChange={handleFilterState}
                                    isClearable
                                    placeholder="Select"
                                    noOptionsMessage={() => 'Nuk u gjet asnjë përputhje'}
                                    components={{ IndicatorSeparator: () => null }}
                                />
                                <span className="clients-error">{stateError && `${stateError}`}</span>
                            </div>

                            <div className="clients-field">
                                <label className="clients-select-label">Përzgjedh Qytetin *</label>
                                <Select
                                    inputId="CityID"
                                    classNamePrefix="clients-select"
                                    value={cityID ? { label: cityName, value: cityID, CityID: cityID } : null}
                                    options={filteredCity.map((data) => ({
                                        label: data.CityName,
                                        value: data.CityID,
                                        CityID: data.CityID,
                                    }))}
                                    onInputChange={handleInputChange}
                                    onChange={handleFilterCity}
                                    isClearable
                                    placeholder="Select"
                                    noOptionsMessage={() => 'Nuk u gjet asnjë përputhje'}
                                    components={{ IndicatorSeparator: () => null }}
                                />
                                <span className="clients-error">{cityError && `${cityError}`}</span>
                            </div>
                        </div>
                    </section>

                    <section className="clients-section">
                        <h6 className="clients-section-title">Kontakt dhe Koment</h6>
                        <div className="clients-grid clients-grid-2">
                            <div className="clients-field">
                                <TextField
                                    fullWidth
                                    id="Email"
                                    label="Email"
                                    variant="outlined"
                                    type="text"
                                    name="Email"
                                    value={accEmail}
                                    onChange={(event) => {
                                        setAccEmail(event.target.value);
                                        if (emailError) {
                                            setEmailError("");
                                        }
                                    }}
                                    autoComplete="off"
                                    size="small"
                                />
                                <span className="clients-error">{emailError && `${emailError}`}</span>
                            </div>

                            <div className="clients-field">
                                <TextField
                                    fullWidth
                                    id="PhoneNumber"
                                    label="Numri i Telefonit"
                                    variant="outlined"
                                    type="text"
                                    name="PhoneNumber"
                                    value={phone}
                                    onChange={(event) => {
                                        setPhone(event.target.value);
                                        if (phoneError) {
                                            setPhoneError("");
                                        }
                                    }}
                                    autoComplete="off"
                                    size="small"
                                />
                                <span className="clients-error">{phoneError && `${phoneError}`}</span>
                            </div>

                            <div className="clients-field clients-field-full">
                                <textarea
                                    rows={2}
                                    className="clients-notes"
                                    id="Comment"
                                    placeholder="Komenti"
                                    name="Comment"
                                    value={comment}
                                    onChange={(event) => setComment(event.target.value)}
                                    autoComplete="off"
                                />
                            </div>

                            {isEditMode && (
                                <div className="clients-field clients-field-full">
                                    <label className='InsertModal__Container__Form__Container2__checkbox-label'>
                                        <input
                                            type="checkbox"
                                            checked={isActive}
                                            onChange={(event) => setIsActive(event.target.checked)}
                                            className='InsertModal__Container__Form__Container2__checkbox-input'
                                        />
                                        <span className='InsertModal__Container__Form__Container2__checkbox-custom'></span>
                                        Aktiv
                                    </label>
                                </div>
                            )}
                        </div>
                    </section>

                    <div className="clients-modal-footer">
                        <Button
                            type="submit"
                            variant="contained"
                            className="clients-save-btn"
                            disabled={isSubmitting || (isEditMode && !isDirty)}
                        >
                            {isSubmitting
                                ? "Duke ruajtur..."
                                : isEditMode
                                    ? "Përditëso & Mbyll"
                                    : "Ruaj & Mbyll"}
                        </Button>
                        <Button
                            variant="outlined"
                            className="clients-close-btn"
                            onClick={handleClose}
                            disabled={isSubmitting}
                        >
                            Mbyll
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>

        <Dialog
            open={showConfirmClose}
            onClose={() => setShowConfirmClose(false)}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>Konfirmo mbylljen</DialogTitle>
            <DialogContent>
                Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e ndryshuara do të humbin. A jeni të sigurt?
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
                    Kthehu
                </Button>
                <Button onClick={doClose} variant="contained" color="error">
                    Po, mbyll pa ruajtur
                </Button>
            </DialogActions>
        </Dialog>
        </>
    );
}

export default function CashRegisterModal(props) {
    const [internalModalShow, setInternalModalShow] = React.useState(false);
    const isControlled = typeof props.show === "boolean";
    const modalShow = isControlled ? props.show : internalModalShow;

    const openModal = () => {
        if (isControlled) {
            return;
        }

        setInternalModalShow(true);
    };

    const closeModal = () => {
        if (isControlled) {
            if (props.onHide) {
                props.onHide();
            }
            return;
        }

        setInternalModalShow(false);
    };

    const handleRefreshData = () => {
        if (props.fetchData) {
            props.fetchData();
        }
    };

    return (
        <>
            {!isControlled && (
                <AddElementsButton
                    text="Krijo Arkë"
                    onClick={openModal}
                    icon="bi bi-plus-circle"
                    className="button-68"
                />
            )}

            <InsertCashRegister
                show={modalShow}
                onHide={closeModal}
                refreshData={handleRefreshData}
                mode={props.mode}
                initialData={props.initialData}
            />
        </>
    );
}
